module.exports = __webpack_public_path__ + "static/media/PTSans-Regular.ec84922b.ttf";